import { Layout } from 'spa/components/layout'
import { ModuleLoader } from 'spa/components/module_loader/module_loader'
const PostRoutes = React.lazy(() => import('./post_routes'))

import React from 'react'

const display = () => {
  return (
    <Layout fullLayout tabTitle={location.pathname.substring(1)}>
      <ModuleLoader>
        <PostRoutes />
      </ModuleLoader>
    </Layout>
  )
}

export { display as PostRoutesDisplay }

export { PostRoutes }

export default PostRoutes
